import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function HarborOrderCta() {
  const navigate = useNavigate();

  return (
    <section className="pfp-harbor-order-cta" aria-label="Tagesauftrag annehmen">
      <div className="pfp-harbor-order-cta__icon" aria-hidden="true">📜</div>
      <div className="pfp-harbor-order-cta__content">
        <span className="pfp-harbor-order-cta__kicker">Freibeuterhafen</span>
        <h2>Noch kein Tagesauftrag aktiv</h2>
        <p>
          Nimm im Freibeuterhafen einen Tagesauftrag an und sammle gezielt zusätzliche Belohnungen.
        </p>
      </div>
      <button type="button" className="pfp-harbor-order-cta__button" onClick={() => navigate('/freibeuterhafen')}>
        Tagesauftrag annehmen
      </button>
    </section>
  );
}
